import styled from 'styled-components'

import { white, brightred, bordergray, gold, red } from '../../styles/colors'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: fixed;
  background: ${white};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`

export const Link = styled.div`
  transition: color 0.5s;
  display: inline;
  cursor: pointer;
  color: ${gold};
  &:hover {
    color: ${red};
  }
`

export const InnerContainer = styled.div`
  width: 100%;
  max-width: 500px;
  padding: 1rem;
  border: 1px solid ${bordergray};
  border-radius: 0.25rem;
  background: ${white};
`

export const Title = styled.div`
  font-size: 20px;
  font-weight: 500;
  text-decoration: underline;
  color: ${brightred};
  margin-bottom: 1rem;
`

export const Text = styled.div`
  font-size: 18px;
  line-height: 1.4;
  margin: 1rem 0;
  &:last-child {
    margin-bottom: 0;
  }
`



// WEBPACK FOOTER //
// ./src/components/Error/styles.js